import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import messages from "../../../redux/messages";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import toastr from "toastr";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import CustomNavbar from "../../../components/CustomNavbar";
import SidebarCapacitacion from "../../../components/capacitacionDesarrollo/SidebarCapacitacion";
import { getPersonalDivision } from "../../../redux/divisionPersonal/actions";
import { getOrgs } from "../../../redux/organization/actions";
import {
  getBudgets,
  createBudget,
  deleteBudget,
} from "../../../redux/capacitacionDesarrollo/BudgetControl/actions";

const CompaniesBudget = (props) => {
  const schema = Yup.object().shape({
    organizacion_id: Yup.number().required("Debe seleccionar una empresa"),
    zona_division_id: Yup.number().required("Debe seleccionar una zona"),
  });

  // Estados Redux
  const dispatch = useDispatch();

  // Store
  const {
    divisionPersonal,
    loading: loadingZones,
    /* divisionPersonalError */
  } = useSelector((store) => store.divisionPersonal);
  const {
    budgets,
    budgetsLength,
    loading: loadingBudgets,
    saveLoading,
    budgetsError,
  } = useSelector((store) => store.trainingBudgetControl);

  const { orgs: companies, loading: loadingCompanies } = useSelector(
    (store) => store.orgs
  );

  // Estados
  const [show, setShow] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "empresa",
    desc: "Empresa",
  });

  // Paginación
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const filters = [
    { id: "empresa", desc: "Empresa" },
    { id: "zona", desc: "Zona" },
  ];

  const pages = Math.ceil(budgetsLength / limit);

  const columns = [
    {
      Header: "Empresa",
      accessor: "organizacion_nombre",
      Cell: ({ value }) => value || "No asignada",
    },
    {
      Header: "Zona",
      accessor: "empresa_zona_nombre",
      Cell: ({ value }) => value || "No asignada",
    },
    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Cell: ({ value }) => (
        <div>{moment(value).format("DD/MM/YYYY HH:mm")}</div>
      ),
    },
    {
      id: "actions",
      Cell: ({ row }) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            onClick={() => onDelete(row.original.id)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Metodos
  const fetchBudgets = () => {
    const params = {
      limit,
      offset,
    };

    if (filter) {
      params.filter = filter;
      params.tipo_busqueda = tipoBusqueda.id === "zona" ? "zona" : "empresa";
    }

    dispatch(getBudgets(params));
  };

  const onDelete = (id) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteBudget(id))
        .then(() => {
          fetchBudgets();
        })
        .catch(() => {
          toastr.error("Error al eliminar el registro");
        });
    }
  };

  const seeAll = () => {
    setFilter("");
    setOffset(0);
    setCurrentPage(1);
    fetchBudgets();
  };

  const onAdd = () => {
    setShowFormModal(true);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    setOffset(0);
    setCurrentPage(1);
  };

  const onSubmit = (values) => {
    dispatch(createBudget(values))
      .then(() => {
        setShowFormModal(false);
        fetchBudgets();
      })
      .catch(() => {
        toastr.error("Error al crear el registro");
      });
  };

  const onShowSidebar = () => setShow(!show);

  useEffect(() => {
    if (!companies.length && !loadingCompanies) {
      dispatch(getOrgs(2));
    }
    if (!divisionPersonal.length && !loadingZones) {
      dispatch(getPersonalDivision());
    }

    fetchBudgets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, offset, limit, filter]);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCapacitacion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              Empresas Presupuesto
            </h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  />
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={seeAll}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={onAdd}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip>Seleccionar Filtrado</Tooltip>}
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              key={item.id}
                              onClick={() => setTipoBusqueda(item)}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>

          {budgetsError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {budgetsError}
            </Alert>
          )}

          {loadingBudgets ? (
            <div className="text-center my-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : budgets.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable
                    columns={columns}
                    data={budgets}
                    loading={loadingBudgets}
                  />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={budgetsLength}
                pages={pages}
                pagFunc={() => fetchBudgets()}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>

        <Modal
          show={showFormModal}
          onHide={() => setShowFormModal(false)}
          centered
        >
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              organizacion_id: "",
              zona_division_id: "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>Agregar Empresa</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label>Empresa *</Form.Label>
                    <Form.Control
                      as="select"
                      name="organizacion_id"
                      value={values.organizacion_id}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={
                        touched.organizacion_id && !!errors.organizacion_id
                      }
                      disabled={loadingCompanies}
                    >
                      <option value="">Seleccione una empresa</option>
                      {companies.map((org) => (
                        <option key={org.id} value={org.id}>
                          {org.nombre}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.organizacion_id}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group as={Col} className="mb-3">
                    <Form.Label>Zona *</Form.Label>
                    <Form.Control
                      as="select"
                      name="zona_division_id"
                      value={values.zona_division_id}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={
                        touched.zona_division_id && !!errors.zona_division_id
                      }
                      disabled={loadingZones}
                    >
                      <option value="">Seleccione una zona</option>
                      {divisionPersonal.map((zone) => (
                        <option key={zone.id} value={zone.id}>
                          {zone.descripcion}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.zona_division_id}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cancelar
                  </Button>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={saveLoading}
                  >
                    {saveLoading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="mr-2"
                        />
                        Guardando...
                      </>
                    ) : (
                      "Guardar"
                    )}
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
      </div>
    </>
  );
};

export default CompaniesBudget;
